import CloseIcon from "@mui/icons-material/Close";
import {
	Dialog,
	DialogContent,
	type DialogProps,
	DialogTitle,
	SvgIcon,
	Typography,
	styled,
} from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";

const StyledDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialog-paper": {
		backgroundColor: theme.palette.background.paper,
		paddingInline: "4%",
		paddingBlock: theme.spacing(10),
		borderRadius: "14px",
	},
}));

type AppDialogProps = PropsWithChildren<
	Omit<DialogProps, "title" | "children"> & {
		title?: ReactNode;
	}
>;

const AppDialog: React.FC<AppDialogProps> = ({
	title = "",
	children,
	...dialogProps
}) => {
	return (
		<StyledDialog fullWidth {...dialogProps}>
			<DialogTitle
				sx={{
					p: 0,
					mb: 7,
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Typography color="grey.300" variant="h5" component="p">
					{title}
				</Typography>
				<SvgIcon
					onClick={dialogProps.onClose as any}
					sx={{ cursor: "pointer" }}
				>
					<CloseIcon />
				</SvgIcon>
			</DialogTitle>

			<DialogContent sx={{ p: 0 }}>{children}</DialogContent>
		</StyledDialog>
	);
};

export default AppDialog;
